import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';

import { changeFormField } from 'apps/auth/actions/formAction';
import { CalculatorAmountBlock, CalculatorFrame, CalculatorFrameTop, CalculatorInputLabel, Helper } from 'apps/auth/components/common/Calculator/styles';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import InputAmount from 'apps/auth/components/form-multi/InputAmount';
import { AMOUNT_TO } from 'apps/auth/constants/fieldsName';
import { TOP_UP_ACCOUNT } from 'apps/auth/constants/formName';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useApp, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';

import TopUpLimitsPopup from '../../popups/TopUpLimitsPopup';

const TopUpCalcGooglePay = (props) => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const popupRef = useRef(null);

    const { topUpPayTitle, newBalance } = usePageMessages();
    const { account, minAmount, maxAmount } = useExtra();
    const [amountFromFloatValue, setAmountFromFloatValue] = useState();

    const getSecondaryText = () => {
        const currentAmount = account?.balance;
        const amountFrom = props.amountFrom;
        const amountCurrency = account?.pocketCurrency.code;
        if (amountFrom.value) {
            const amountFromValue = amountFromFloatValue;
            if (amountFrom.isError) {
                const isShowIcon = parseFloat(amountFromValue) > parseFloat(maxAmount?.amount);
                return (
                    <Helper noPadding>
                        <Text size="secondary" color="error">
                            {amountFrom.errorMessage}
                        </Text>
                        {isShowIcon && getErrorInfoIcon()}
                    </Helper>
                );
            } else {
                const newAmount = parseFloat(currentAmount) + parseFloat(amountFromValue);
                return (
                    <Helper noPadding>
                        <Text size="secondary" color="secondary">
                            {resolveArguments(newBalance, getLocalizedRawAmount(lang, country, newAmount))}
                            <Text size="secondary" color="secondary" smallCaps>
                                {' ' + amountCurrency}
                            </Text>
                        </Text>
                    </Helper>
                );
            }
        } else {
            return false;
        }
    };
    const onProcessLinkClick = (value) => {
        const newField = {
            ...props.amountFrom,
            value: String(value),
            isError: false,
            errorMessage: '',
        };
        props.changeFormField(props.formName, newField);
    };

    const getErrorInfoIcon = () => {
        const amountFrom = props.amountFrom;
        return (
            <DiskButton
                size="small"
                iconName="info-rounded"
                iconColor="error"
                type="button"
                raised={false}
                title={amountFrom.errorMessage}
                onClick={(e) => {
                    e.preventDefault();
                    popupRef.current?.open(<TopUpLimitsPopup popupRef={popupRef} onProcessLinkClick={onProcessLinkClick} />);
                }}
            />
        );
    };

    return (
        <>
            <CalculatorFrame>
                <CalculatorFrameTop>
                    <CalculatorAmountBlock>
                        <CalculatorInputLabel size="secondary" color="secondary">
                            {topUpPayTitle}
                        </CalculatorInputLabel>
                        <InputAmount
                            googlePay={true}
                            field={props.amountFrom}
                            formName={props.formName}
                            minAmount={minAmount}
                            maxAmount={maxAmount}
                            classNameError={props.amountFrom?.isError}
                            minAmountErrorKey={'site.js.ga.validation.min.valid.error'}
                            maxAmountErrorKey={'site.js.ga.validation.max.valid.error'}
                            enabledValidateMinMaxAmount={true}
                            currencyCode={account?.pocketCurrency.code}
                            validateOnBlur={false}
                            isNewInput
                            isCalculatorInput
                            setAmountFromFloatValue={setAmountFromFloatValue}
                        />
                        {getSecondaryText()}
                    </CalculatorAmountBlock>
                </CalculatorFrameTop>
            </CalculatorFrame>
            <PopupNew ref={popupRef} />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        amountFrom: state.form[TOP_UP_ACCOUNT].fields[AMOUNT_TO],
    };
};
export default connect(mapStateToProps, { changeFormField })(TopUpCalcGooglePay);
